import { render } from "./FactsComponent.vue?vue&type=template&id=614aa31e&scoped=true"
import script from "./FactsComponent.vue?vue&type=script&lang=js"
export * from "./FactsComponent.vue?vue&type=script&lang=js"

import "./FactsComponent.vue?vue&type=style&index=0&id=614aa31e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-614aa31e"]])

export default __exports__